import React, { FC } from "react";
import laptopScrewdriver from "@/assets/studentTile/laptop-screwdriver.svg?url";
import { Image, Text, Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import IconTileContentLayout from "js/components/StudentTile/components/IconTileContentLayout";

const CannotDisplayActivity: FC = () => {
	const { t } = useTranslation();
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex flexDirection={"column"} align={"center"} justifyContent={"center"} height={tileSize === "sm" ? "100%" : undefined}>
			<IconTileContentLayout>
				{tileSize !== "sm" && (
					<Image mt={tileSize === "lg" ? 6 : 2} src={laptopScrewdriver} htmlHeight={42} htmlWidth={42} mb={tileSize === "lg" ? 4 : 1} />
				)}
				<Text fontWeight={"bold"} lineHeight={1.2}>
					{t("studentTile.cannotDisplayActivityTitle")}
				</Text>
				<Text lineHeight={1.2}>{t("studentTile.cannotDisplayActivitySubtitle")}</Text>
			</IconTileContentLayout>
		</Flex>
	);
};

export default CannotDisplayActivity;
